import React from "react";
import Mydata from "../../data/blog/firstclass.json";

function Table() {
  const Data = Mydata[2]; // Adjust index if necessary
  return (
    <div className="mx-auto max-w-5xl px-4 text-[#2B3252] space-y-6 text-lg">
      {/* Mapping each section */}
      {Data.sections.map((section, index) => (
        <div key={index} className="mb-6">
          {/* Display title if it exists */}
          {section.title && (
            <h2 className="blogtitle">{section.title}</h2>
          )}

          {/* Check if section.content is an array before mapping */}
          {Array.isArray(section.content)
            ? section.content.map((contentItem, contentIndex) => (
                <div key={contentIndex} className="mb-3">
                  {contentItem.type === "paragraph" && (
                    <p className="mb-3">{contentItem.text}</p>
                  )}
                  {contentItem.type === "bullets" && (
                    <ul className="list-disc  space-y-2 pl-3">
                      {contentItem.points.map((point, pointIndex) => (
                        <li
                        key={pointIndex}
                        dangerouslySetInnerHTML={{ __html: point }}
                      ></li>
                      ))}
                    </ul>
                  )}
                </div>
              ))
            : /* Render content directly if it's not an array (assuming it's a simple string) */
              section.content && <p
              className="mb-4"
              dangerouslySetInnerHTML={{ __html: section.content }}
            ></p>
            }

          {/* If section contains a table */}
          {section.table && (
            <div className="overflow-x-auto mt-4">
              <table className="min-w-full bg-white border border-gray-300 text-left text-lg">
                <thead className="cardbg">
                  <tr>
                    {section.table.header.map((header, headerIndex) => (
                      <th
                        key={headerIndex}
                        className="py-2 px-4 border border-gray-300 font-semibold"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {section.table.rows.map((row, rowIndex) => (
                    <tr key={rowIndex} className="">
                      <td className="py-2 px-4 border border-gray-300">
                        {row.type}
                      </td>
                      <td className="py-2 px-4 border border-gray-300">
                        {row.benefits.join(", ")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default Table;
